import axios from 'axios';



export default axios.create({
	baseURL: 'https://dbsikuraja.otnielpangkung.com/',
	// baseURL: 'https://testdbsikuraja.otnielpangkung.com/',
	// baseURL: 'http://localhost:3001',
	// 	baseURL: 'http://192.168.11.11:3001',
});

 